import React, { useState } from 'react'
import { store } from '../../../../store/favor/store'

export function FavorTab() {


  const redirect = (url: string, msg: string) => {
    let title = store.currentFavor?.gname
    let code = store.currentFavor?.gid

    if (title && code) {
      location.href = url + code
      return
    }
  }

  return (
    <>
      <ul className="comm-tabs">
        <li>
          <a href="/quote/index.html">行情中心</a>
        </li>
        <li>
          <a href="//mguba.eastmoney.com">股吧社区</a>
        </li>
        <li>
          <a href="#" onClick={(e) => {e.preventDefault();redirect('info.html?id=', '资讯')}}>
            自选资讯
          </a>
        </li>
        <li>
          <a href="#" onClick={(e) => {e.preventDefault();redirect('notice.html?id=', '公告')}}>
            自选公告
          </a>
        </li>
      </ul>
    </>
  )
}
